import script from "./aside.vue?vue&type=script&setup=true&lang=ts"
export * from "./aside.vue?vue&type=script&setup=true&lang=ts"

import "./aside.vue?vue&type=style&index=0&id=089ccc4c&scoped=true&lang=less"
import "./aside.vue?vue&type=style&index=1&id=089ccc4c&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-089ccc4c"]])

export default __exports__